import { Card } from "src/components/UI/Card";
import TitleTooltip from "src/components/UI/TitleTooltip";
import { KeywordAssistPageDetail } from "../../types/keyword-assist.type";

interface Props {
    meta: KeywordAssistPageDetail;
}

const BulbIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.8" stroke="currentColor" className="w-5 h-5 text-[#4F46E5] mt-0.5 shrink-0">
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 18a3.75 3.75 0 0 0 .495-7.467 5.99 5.99 0 0 0-1.925 3.546 5.974 5.974 0 0 1-2.133-1A3.75 3.75 0 0 0 12 18Z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 2.25V4.5m5.303.197-1.591 1.591M21.75 12h-2.25m-.197 5.303-1.591-1.591M12 21.75V19.5m-5.303-.197 1.591-1.591M2.25 12h2.25m.197-5.303 1.591 1.591" />
    </svg>
);

export default function KAAIOptimizationChecklist({ meta }: Props) {
    return (
        <Card className="flex flex-col justify-between h-full">
            <div className="px-6">
                <div className="flex justify-between items-start mb-4">
                    <div>
                        <TitleTooltip>
                            <TitleTooltip.Text title="AI Recommendations" className="!text-[#475467] !font-medium !text-base" />
                        </TitleTooltip>
                        <p className="text-sm text-[#8E8EA9] mt-0.5">Apply these recommendations to drive optimization scores upwards.</p>
                    </div>
                    <div className="text-center bg-[#ECFDF3] rounded-full">
                        <span className="inline-block text-[#027A48] px-2.5 py-1 text-xs font-bold uppercase tracking-wider shadow-sm">
                            {meta.ai_recommendations.impact}
                        </span>
                    </div>
                </div>

                {/* Recommendations List */}
                <div className="space-y-2">
                    {meta.ai_recommendations.items.map((point, index) => {
                        return (
                            <div
                                key={index}
                                className="flex items-start gap-3 p-3 border border-[#E6E6F2] bg-[#F8F9FC]/40 rounded-xl"
                            >
                                <span className="flex items-center justify-center shrink-0 w-5 h-5 bg-[#EEF2F6] text-[#475467] rounded-full text-xs font-bold">
                                    {index + 1}
                                </span>
                                <p className="text-xs font-semibold text-[#344054]">
                                    {point}
                                </p>
                            </div>
                        );
                    })}
                </div>

                {/* Insights/Notes Callout box */}
                <div className="bg-[#d5d7de] border border-[#EAECF0] rounded-xl p-3 flex gap-3 mt-4 items-start">
                    <BulbIcon />
                    <div className="flex flex-col gap-0.5">
                        <span className="text-sm font-bold text-[#1D2939]">Auditor's Insights</span>
                        <p className="text-xs text-[#475467] font-semibold">
                            {meta.ai_recommendations.auditor_insights}
                        </p>
                    </div>
                </div>
            </div>
        </Card>
    );
}
